"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:title": "Anbefalte tiltak",
  "ui:options": {
    "sortable": true,
    "spacing": 1
  },
  "ui:preview": {
    "select": {
      "title": "title"
    },

    prepare({
      formData
    }) {
      let title = "Anbefalte tiltak";
      let count = formData && formData.length;

      if (count) {
        title = count + " anbefalte tiltak";
      }

      return {
        title: title
      };
    }

  },
  "ui:buttons": [{
    "icon": "add",
    "label": "Foreslå tiltak"
  }],
  "ui:buttonGroupProps": {
    "fullWidth": true
  },
  "items": {
    "ui:title": "Forslag",
    "ui:field": "primusMeasure",
    //        "ui:layout": "module",
    "ui:buttons": [{
      "type": "save",
      "icon": "check",
      "label": "Lagre og lukk"
    }],
    "ui:preview": {
      "select": {
        "title": "title",
        "description": "description"
      },

      prepare({
        formData
      }) {
        const title = formData && formData.title || "Tiltak";
        let metadata = [];

        if (formData && formData.details) {
          formData && formData.costEstimate && metadata.push(formData.costEstimate + " kr");
          formData && formData.timeEstimate && metadata.push(formData.timeEstimate + " timer");
        }

        const description = metadata.join(' – ') || "Ingen estimater";
        return {
          title: title,
          description: description
        };
      }

    },
    "ui:options": {
      "editable": true,
      "grid": true,
      "spacing": 2
    },
    "title": {
      "ui:title": "Forslag til tiltak",
      "ui:help": "Hva skal til for å løse problemet?"
    },
    "details": {
      "ui:title": "Vet du hva tiltaket vil koste eller hvor lang tid det tar?",
      "ui:widget": "radio",
      "ui:inline": true
    },
    "costEstimate": {
      "ui:title": "Estimert kostnad",
      "ui:help": "Estimert kostnad i norske kroner",
      "ui:gridCols": 6
    },
    "timeEstimate": {
      "ui:title": "Estimert tidsbruk",
      "ui:help": "Antall timer",
      "ui:gridCols": 6
    }
  }
};
exports.default = _default;
module.exports = exports.default;